import script from "./batchDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./batchDialog.vue?vue&type=script&lang=ts&setup=true"

import "./batchDialog.vue?vue&type=style&index=0&id=05be7b30&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05be7b30"]])

export default __exports__